/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      const button = document.getElementById( 'load-more-projects' );
      const container = document.querySelector( '.ajax-results' );
      const maxPaged = parseInt( button.dataset.maxPaged );

      loadMoreProjects( true );

      $( document ).on( 'click', '#load-more-projects', function() {
        loadMoreProjects( true );
      } );

      function loadMoreProjects( updatePage = false ) {
        let paged = parseInt( button.dataset.paged );

        if ( paged > maxPaged ) return;

        button.disabled = true;
        button.textContent = 'Loading...';

        const data = {
          'paged': paged,
        };

        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'cpt/loadMore',
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            console.log( data );
            container.insertAdjacentHTML( 'beforeend', data.html );
            if ( updatePage ) {
              paged++;
              button.dataset.paged = paged;
            }

            if ( paged > data.max_paged ) {
              button.style.display = 'none';
            } else {
              button.disabled = false;
              button.textContent = 'Load More';
            }
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
          error: function( jqXHR, status ) {
            console.log( status );
            doingAjax = false;
          },
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'projects', COMPONENT );
} )( app );
